var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const Loading = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-loading ${className}`} {...other}>
      <g>
        <path d="M8.275 13.001a1.316 1.316 0 110 2.631 1.316 1.316 0 010-2.63zm-5.462-1.57a1.504 1.504 0 112.126 2.127 1.504 1.504 0 01-2.126-2.127zm9.064.266a1.127 1.127 0 11-.087.099l.087-.099zM2.054 6.592a1.504 1.504 0 110 3.007 1.504 1.504 0 010-3.007zm12.443.563a.94.94 0 110 1.88.94.94 0 010-1.88zM4.939 2.633a1.503 1.503 0 11-2.126 2.126 1.503 1.503 0 012.126-2.126zm7.736.311a.752.752 0 110 1.503.752.752 0 010-1.503zM8.275.37a1.504 1.504 0 110 3.007 1.504 1.504 0 010-3.007z" fillRule="evenodd">
          <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 8 8" to="360 8 8" dur="1s" repeatCount="indefinite"/>
        </path>
      </g>
    </Base>);
};
export default Loading;
